
import { of as observableOf, Subscription, Observable } from 'rxjs';
import { Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild, OnChanges, SimpleChange, OnDestroy } from "@angular/core";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { TaxReturnActionsComponent } from "../tax-return-actions/tax-return-actions.component";
import { ActivatedRoute, Router } from "@angular/router";
import { ITaxReturn } from "../../../app/tax-returns/tax-return/model/i-tax-return";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import {
  AssigneeService,
  ClientService,
  ListOfClients,
  TaxReturnService,
  PostTaxReturnBrief, Batch
} from "../../../../swaggerServices";
import { PopulationRouteResolver } from "../../../app/clients/population-taxpayers/population-route-resolver.service";
import moment from "moment";
import { IClient } from "../../../app/sidebar/client-sidebar/client-sidebar.component";
import { getQuestionnaireType, getQuestionnaireTypes } from "../../util/questionnaire-type.util";
import { ConfigStateService } from "../../../app/config/config-state.service";
import { TenantConfigService } from "../../../shared/services/tenant-config.service";
import { TaxReturnStatus, TaxReturnAction } from "../../../app/tax-returns/tax-return/model/status";
import { AssigneeWithTaxReturns, IAssignee } from "../../types/assignee";
import { TaxReturnTypeSubTypeService } from "../../../shared/util/tax-return-type-subtype.service";
import { DropdownListOption } from "../../../shared/components/search-dropdown/search-dropdown.component";
import { switchMap } from "rxjs/operators";
import { Tenant } from "../../types/tenant.enum";
import { TranslocoService} from "@jsverse/transloco";
import { UserInfoService } from '../../../app/user-info.service';

const numberPattern = /^\d+$/;
declare var $: any;

interface TaxpayerVirtualRow {
  assignee: AssigneeWithTaxReturns;
  taxReturn: ITaxReturn;
}

@Component({
    selector: 'app-taxpayer-list',
    templateUrl: './taxpayer-list.component.html',
    styleUrls: ['./taxpayer-list.component.scss'],
    animations: [
        trigger('visible', [
            state('false', style({
                opacity: 0
            })),
            state('true', style({
                opacity: 1
            })),
            transition('false => true', animate('100ms ease-in')),
            transition('true => false', animate('100ms ease-out')),
        ]),
    ],
    standalone: false
})
export class TaxpayerListComponent implements OnInit, OnChanges {
  @Input() assignees: AssigneeWithTaxReturns[] = [];
  @Input() showTaxReturnType: boolean;
  @Input() showQnrType: boolean;
  @Input() isClientTaxreturnsPage?: boolean;
  @Input() currentBatchList: Batch[];
  @Input() selectedBatchId: number;
  @Input() customFilters: number;
  @Input() taxReturnTypeById
  @Input() taxReturnSubTypeById
  @Input() client
  @Output() refreshRequired: EventEmitter<void> = new EventEmitter<void>();
  @Output() disableAllStartProcess: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild(TaxReturnActionsComponent) taxReturnActionsComponent: TaxReturnActionsComponent;
  @Output() addSpouse: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild('addSpouseModal') addSpouseModalEl: ElementRef;
  @ViewChild('addSpouseSuccessModal') addSpouseSuccessModalEl: ElementRef;
  @ViewChild('moveTaxpayerModal') moveTaxpayerModalEl: ElementRef;
  @ViewChild('moveTaxpayerSuccessModal') moveTaxpayerSuccessModalEl: ElementRef;
  @ViewChild('clientDropdown') clientDropdown: ElementRef;
  @ViewChild('populationDropdown') populationDropdown: ElementRef;
  @ViewChild('taxReturnInfoModal') taxReturnInfoModalEl: ElementRef;
  @ViewChild('notesModal') notesModalEl: ElementRef;

  subscriptions: Subscription[] = [];
  tenants: any;

  addSpouseForm: UntypedFormGroup;
  spouseFirstName: UntypedFormControl;
  spouseLastName: UntypedFormControl;
  spouseTaxId: UntypedFormControl;
  spouseAtlasId: UntypedFormControl;
  spouseGtsId: UntypedFormControl;
  taxReturnType: UntypedFormControl;
  taxReturnSubtype: UntypedFormControl;
  qnrType: UntypedFormControl;

  addingSpouse: boolean;
  spouseAssignee: IAssignee;
  assigneeToMove: IAssignee;
  taxReturnToMove: ITaxReturn;
  clients: ListOfClients;
  assigneeNewPopulationId: number;
  taxReturnInfoFields: { key: string, value: any }[];
  taxYr: string = String(this.activatedRoute.queryParams['value'].taxYear);
  assigneeForNotes: IAssignee;
  taxReturnForNotes: ITaxReturn;
  showBulkProcess: boolean = false;
  bulkProcessPopulationId: number;
  taxIdVariable: string;
  showBulkActions: boolean = false;
  selectedTaxReturns = {};
  allowMoveAssigneeAcrossClient = true;
  isPopulationPage = false;
  showTypeSubType: boolean = true;
  showBulkProcessButton: boolean = false;
  cnDocsTenants: boolean = false;
  taxReturnAlias: string;
  taxpayerAlias: string;
  syncToOneTeamStatus: string;
  atlasIdVariable: string;
  entityPrimaryName: string;
  entitySecondaryName: string;
  atlasId: string;
  gtsId: string;
  oneTeamIntegrationEnabled: boolean;

  private visibleTaxReturns = [];
  virtualRows: TaxpayerVirtualRow[] = [];

  taxReturnTypeOptions: DropdownListOption[];
  taxReturnSubtypeOptions: DropdownListOption[];
  qnrTypeOptions: DropdownListOption[];

  disableStartProcess = false;
  disableBulkStartProcess = false;
  constructor(private router: Router,
    private taxReturnService: TaxReturnService,
    private populationRouteResolver: PopulationRouteResolver,
    private zone: NgZone,
    private clientService: ClientService,
    private activatedRoute: ActivatedRoute,
    private assigneeService: AssigneeService,
    public config: ConfigStateService,
    private typeSubtypeService: TaxReturnTypeSubTypeService,
    private translocoService: TranslocoService,
    public userInfo: UserInfoService
  ) {
  }

  get showBulkProcessBtn(): boolean {
    return this.bulkProcessPopulationId && this.hasNoQnr();
  }

  ngOnChanges(changes) {
    if (changes.assignees) {
      const trIds = [];
      const openTaxReturnRows: TaxpayerVirtualRow[] = [];
      const closedTaxReturnRows: TaxpayerVirtualRow[] = [];
      this.assignees.forEach(assignee => {
        assignee.taxReturns.forEach(taxReturn => {
          trIds[taxReturn.id] = taxReturn;
          if (taxReturn.status === TaxReturnStatus.CLOSED.id) {
            closedTaxReturnRows.push({ assignee, taxReturn });
          } else {
            openTaxReturnRows.push({ assignee, taxReturn });
          }
        });
      });
      this.visibleTaxReturns = trIds;
      this.virtualRows = [...openTaxReturnRows, ...closedTaxReturnRows];
      Object.keys(this.selectedTaxReturns).forEach((i) => {
        if (!trIds[i]) delete this.selectedTaxReturns[i];
      });
    }
  }

  trackByTaxReturnId(index: number, row: TaxpayerVirtualRow): number {
    return row.taxReturn.id;
  }

  ngOnInit() {
    this.bulkProcessPopulationId = Number(this.activatedRoute.params['value'].populationId);
    this.createSpouseForm();
    this.subscriptions.push(this.config.loadConfig().subscribe((config) => {
      const tenant = new TenantConfigService(this.config);
      this.taxIdVariable = tenant.config.taxId;
      this.showBulkActions = (this.isPopulationPage && config.featureFlags.showBulkActionOnPopulationPage) || this.isClientTaxreturnsPage;
      this.allowMoveAssigneeAcrossClient = config.featureFlags.moveAssigneeToDifferentClient;
      this.taxReturnAlias = tenant.config.taxReturnAlias;
      this.taxpayerAlias = tenant.config.taxpayerAlias;
      this.oneTeamIntegrationEnabled=this.config.featureFlags.enableOneteamIntegration;      
      this.syncToOneTeamStatus = tenant.config.otSyncStatus;
      this.entityPrimaryName = tenant.config.entityPrimaryName;
      this.entitySecondaryName = tenant.config.entitySecondaryName;
      this.atlasId = tenant.config.atlasId;
      this.gtsId = tenant.config.gtsId;
      this.atlasIdVariable = tenant.config.atlasId;
      this.translocoService.selectTranslate('tax-payer-alias').subscribe(value => this.taxpayerAlias = value);
      this.translocoService.selectTranslate('tax-return-alias').subscribe(value => this.taxReturnAlias = value);
      this.showBulkProcessButton = this.showQnrType && config.tenant === Tenant.AU;
      if (config.featureFlags.addSpouseRequireTaxId) {
        this.spouseTaxId.setValidators(Validators.required);
      }

      if (this.showQnrType) {
        this.qnrTypeOptions = getQuestionnaireTypes();
      }
      if (config.tenant === Tenant.HK || config.tenant === Tenant.CN) {
        this.cnDocsTenants = true;
      }
    })
    );
    this.isPopulationPage = !!this.activatedRoute.params['value'].populationId;
    this.qnrTypeOptions = getQuestionnaireTypes();
    this.tenants = Tenant;
    this.subscriptions.push(this.activatedRoute.queryParams.subscribe(params => {
      if (params.taxYear) this.taxYr = params.taxYear;
    }));
  }

  onDisableBulkStartProcess() {
    this.disableBulkStartProcess = true;
  }
  disableAllStartProcesses() {
    this.disableStartProcess = true;
  }
  actionRequested({ taxReturn, action }) {
    const populationId = this.getPopulationIdForAction(taxReturn);
    this.taxReturnActionsComponent.doAction(taxReturn, action, populationId);
  }

  bulkProcessNoQnr() {
    this.actionRequested({ taxReturn: this.assignees[0].taxReturns[0], action: TaxReturnAction.BULK_PROCESS_NO_QNR })
  }

  updateSelectAll(selectAll) {
    if (selectAll) {
      this.selectedTaxReturns = this.visibleTaxReturns;
    } else {
      this.selectedTaxReturns = {};
    }
  }

  taxReturnSelectChanged(selected: boolean, taxReturn) {
    if (selected) {
      this.selectedTaxReturns[taxReturn.id] = taxReturn;
    } else {
      delete this.selectedTaxReturns[taxReturn.id];
    }
  }

  private getPopulationIdForAction(taxReturn) {
    let populationId = null;
    if (this.bulkProcessPopulationId) {
      populationId = this.bulkProcessPopulationId;
    } else if (taxReturn && taxReturn.assigneeId) {
      this.assignees.forEach((assignee: IAssignee) => {
        assignee.populations.forEach(pop => {
          if (pop.year === taxReturn.year) {
            populationId = pop.id;
          }
        });
      });
    }
    return populationId;
  }

  navigateToTaxReturn(taxReturn: ITaxReturn) {
    this.router.navigate(['/tax-returns', taxReturn.id]);
  }

  showSpouseForm(assignee: IAssignee, taxReturn: ITaxReturn) {
    this.spouseAssignee = assignee;
    this.addSpouseForm.reset();
    this.initTaxReturnTypeSubType();

    $(this.addSpouseModalEl.nativeElement).modal({
      onApprove: () => {
        this.zone.run(() => {
          this.addSpouseTaxReturn(assignee, taxReturn);
        });
        return false;
      },
    }).modal("show");
  }

  private createSpouseForm() {
    this.spouseFirstName = new UntypedFormControl('', {
      validators: [Validators.required],
    });
    this.spouseLastName = new UntypedFormControl('', {
      validators: this.gtsId ? [Validators.required] : null,
    });
    this.spouseAtlasId = new UntypedFormControl('', {
      validators: [Validators.required, Validators.pattern(numberPattern)],
    });
    this.spouseGtsId = new UntypedFormControl('', {
      validators: this.gtsId ? [Validators.required] : null,
    });
    this.spouseTaxId = new UntypedFormControl('');
    this.taxReturnType = new UntypedFormControl('', {
      validators: [Validators.required],
    });
    this.taxReturnSubtype = new UntypedFormControl('', {
      validators: [Validators.required],
    });
    this.qnrType = new UntypedFormControl('');
    this.addSpouseForm = new UntypedFormGroup({
      spouseFirstName: this.spouseFirstName,
      spouseLastName: this.spouseLastName,
      spouseGtsId: this.spouseGtsId,
      spouseAtlasId: this.spouseAtlasId,
      spouseTaxId: this.spouseTaxId,
      taxReturnType: this.taxReturnType,
      taxReturnSubtype: this.taxReturnSubtype,
      qnrType: this.qnrType,
    });
  }

  addSpouseTaxReturn(assignee: IAssignee, taxReturn: ITaxReturn) {
    if (!this.addSpouseForm.valid) {
      for (const control of Object.values(this.addSpouseForm.controls)) {
        control.markAsDirty();
      }
      this.focusFirstInvalidInput();
      return;
    }
    const req: PostTaxReturnBrief = {
      firstName: this.spouseFirstName.value,
      lastName: this.spouseLastName.value,
      atlasId: this.spouseAtlasId.value,
      gtsId: this.gtsId ? this.spouseGtsId.value : this.spouseAtlasId.value,
      assigneeId: assignee.id,
      year: taxReturn.year,
      taxReturnTypeId: this.taxReturnType.value,
      taxReturnSubTypeId: this.taxReturnSubtype.value,
      questionnaireTypeId: this.qnrType.value
    };

    if (this.config.featureFlags.addSpouseRequireTaxId) {
      req.taxId = this.spouseTaxId.value;
    }
    this.addingSpouse = true;
    this.taxReturnService.addSpouseTaxReturn(taxReturn.id, req).subscribe(() => {
      $(this.addSpouseSuccessModalEl.nativeElement).modal('show');
      this.populationRouteResolver.refreshPopulation(assignee.assigneePopulation.populationId);
      this.addingSpouse = false;
    },
      () => this.addingSpouse = false);
  }

  checkCountryAccess(countryId) {
    if (this.userInfo.isSuperAdmin) return true;
    if (!countryId) return true; // BASE 
    if (this.userInfo.countries.some(c => c.id == countryId)) return true;
    else return false;
  }

  showMoveTaxpayerForm(assignee: IAssignee, taxReturn: ITaxReturn) {
    this.assigneeToMove = assignee;
    this.taxReturnToMove = taxReturn;

    const initClientPopulationsDropdown = (values) => {
      $(this.populationDropdown.nativeElement).dropdown({
        values: values,
        placeholder: "Select...",
        fullTextSearch: "exact",
        preserveHTML: false,
        onChange: (populationId: number) => {
          if (populationId) this.assigneeNewPopulationId = populationId;
        }
      });
    };

    const initClientsDropdown = (values) => {
      //init population dropdown based on default selected ClientId
      if (clientId) {
        this.assigneeNewPopulationId = null;
        this.clientService.getClientById(clientId, taxReturn.year).subscribe((client: IClient) => {
          // disable taxreturn's current population
          const populationId = this.taxReturnToMove.populationId;
          const dropdownVals = client.populations.filter(p => p.status === 0).map(population => {
            return {
              name: population.name,
              value: population.id,
              disabled: population.id === populationId
            }
          });
          initClientPopulationsDropdown(dropdownVals);
        });
      }
      $(this.clientDropdown.nativeElement).dropdown({
        values: values,
        placeholder: "Select...",
        fullTextSearch: "exact",
        preserveHTML: false,
        onChange: (clientId: number) => {
          if (clientId) {
            this.assigneeNewPopulationId = null;
            this.clientService.getClientById(clientId, taxReturn.year).subscribe((client: IClient) => {
              // disable taxreturn's current population
              let populationId = this.taxReturnToMove.populationId;
              const dropdownVals = client.populations.filter(p => p.status === 0).map(population => {
                return {
                  name: population.name,
                  value: population.id,
                  disabled: population.id === populationId
                }
              });
              initClientPopulationsDropdown(dropdownVals);
            });
          }
        }
      });
    };

    // default to the current client of taxpayer
    const clientId = this.assigneeToMove.populations
      ? this.assigneeToMove.populations[0].clientId // when on taxpayer search route
      : Number(this.activatedRoute.params['value'].clientId); // on populations route

    if (!this.clients) {
      this.clientService.getClients(taxReturn.year).subscribe((clients: IClient[]) => {
        this.clients = clients.filter(c => c.status === 0 && this.checkCountryAccess(c.countryId));
        const dropdownVals = this.clients.map(client => {
          return {
            name: client.name,
            value: client.id,
            selected: client.id === clientId
          }
        });
        initClientsDropdown(dropdownVals);
      });
    } else {
      const dropdownVals = this.clients.filter(c => this.checkCountryAccess(c.countryId)).map(client => {
      
        return {
          name: client.name,
          value: client.id,
          selected: client.id === clientId
        };
      });
      initClientsDropdown(dropdownVals);
    }

    $(this.moveTaxpayerModalEl.nativeElement).modal({
      autofocus: false,
      onApprove: () => {
        this.assigneeService.moveAssigneeToAnotherPopulation(this.taxReturnToMove.id, this.assigneeNewPopulationId)
          .subscribe(() => {
            $(this.moveTaxpayerSuccessModalEl.nativeElement).modal('show');
            this.refreshRequired.emit();
          });
      },
    }).modal("show");

  }

  focusFirstInvalidInput() {
    const invalidEls = $(this.addSpouseModalEl.nativeElement).find('input.ng-invalid');
    if (invalidEls) {
      invalidEls[0].focus();
    }
  }

  viewInfo(taxReturn: ITaxReturn) {
    const dateFormat = "DD/MM/YYYY h:mm:ssa";
    const statusText = taxReturn.fullStatus ? `${taxReturn.status} - ${taxReturn.fullStatus.name}` : `${taxReturn.status}`;
    this.taxReturnInfoFields = [
      { key: `${this.taxReturnAlias} ID`, value: taxReturn.id },
      { key: "First Name", value: taxReturn.firstName },
      { key: "Last Name", value: taxReturn.lastName },
      { key: "Status", value: statusText },
      { key: "Year", value: taxReturn.year },
      { key: "Assignee ID", value: taxReturn.assigneeId },
      this.config.tenant === Tenant.DMAAS || this.config.tenant === Tenant.DFAM || this.config.tenant === Tenant.JPCORP
        ? { key: "", value: taxReturn.spouse }
        : { key: "Spouse", value: taxReturn.spouse },
      { key: `Parent ${this.taxReturnAlias} ID`, value: taxReturn.parentTaxReturnId },
      taxReturn.apsTaxReturnId
        ? { key: `APS ${this.taxReturnAlias} ID`, value: taxReturn.apsTaxReturnId }
        : { key: "", value: taxReturn.apsTaxReturnId },
      this.cnDocsTenants
        ? { key: "CNDocs ID (Taxpayer)", value: taxReturn.docshareId }
        : this.config.tenant === Tenant.FR
          ? { key: `${this.taxpayerAlias} File Location`, value: taxReturn.docshareId }
          : this.config.tenant === Tenant.AU || this.config.tenant === Tenant.ESS
            ? { key: "Docshare ID (Taxpayer)", value: taxReturn.docshareId }
            : { key: `Folder ID (${this.taxpayerAlias})`, value: taxReturn.docshareId },
      this.cnDocsTenants
        ? { key: "CNDocs ID (Employer)", value: taxReturn.docshareId }
        : this.config.tenant === Tenant.FR
          ? { key: "Employer File Location", value: taxReturn.docshareIdEmployer }
          : this.config.tenant === Tenant.AU || this.config.tenant === Tenant.ESS
            ? { key: "Docshare ID (Employer)", value: taxReturn.docshareIdEmployer }
            : { key: "", value: taxReturn.docshareIdEmployer },
      this.cnDocsTenants
        ? { key: "CNDocs ID (Tax Office)", value: taxReturn.docshareId }
        : this.config.tenant === Tenant.FR
          ? { key: "Tax Office File Location", value: taxReturn.docshareIdTaxOffice }
          : this.config.tenant === Tenant.AU || this.config.tenant === Tenant.ESS
            ? { key: "Docshare ID (Tax Office)", value: taxReturn.docshareIdTaxOffice }
            : { key: "", value: taxReturn.docshareIdTaxOffice },
      { key: `${this.atlasId}`, value: taxReturn.atlasId },
      this.config.tenant === Tenant.DMAAS || this.config.tenant === Tenant.DFAM || this.config.tenant === Tenant.JPCORP
        ? { key: "", value: taxReturn.taxId }
        : { key: this.taxIdVariable, value: taxReturn.taxId },
      { key: this.gtsId, value: taxReturn.gtsId },
      { key: "Questionnaire Type", value: getQuestionnaireType(taxReturn.questionnaireType) },
      { key: `${this.taxReturnAlias} Type`, value: taxReturn.taxReturnTypeName },
      { key: `${this.taxReturnAlias} Subtype`, value: taxReturn.taxReturnSubTypeName },
      { key: `Parent ${this.atlasId}`, value: taxReturn.parentAtlasId },
      { key: "Complexity Preparer", value: taxReturn.complexityPreparer },
      { key: "Complexity Reviewer 1", value: taxReturn.complexityReviewer1 },
      { key: "Complexity Reviewer 2", value: taxReturn.complexityReviewer2 },
      { key: "Created at", value: moment(taxReturn.createdAt).format(dateFormat) },
      { key: "Updated at", value: moment(taxReturn.updatedAt).format(dateFormat) },
      // TODO robot ids?
    ];
    $(this.taxReturnInfoModalEl.nativeElement).modal("show");
  }

  viewNotes(assignee: IAssignee, taxReturn: ITaxReturn) {
    this.assigneeForNotes = assignee;
    this.taxReturnForNotes = taxReturn;
    $(this.notesModalEl.nativeElement).modal({
      autofocus: false,
      onHidden: () => this.assigneeForNotes = undefined // reset notes component
    }).modal("show");
  }

  private hasNoQnr(): boolean {
    let hasNoQnr = false;
    this.assignees.forEach(assignee => {
      assignee.taxReturns.forEach(taxReturn => {
        if (taxReturn.status === TaxReturnStatus.WAITING_PROCESSING_NO_QNR.id) {
          hasNoQnr = true;
        }
      })
    });
    return hasNoQnr;
  }
  OnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  private initTaxReturnTypeSubType() {
    let taxReturnSubTypesApiCall = this.typeSubtypeService.getTaxReturnSubTypes();

    this.subscriptions.push(taxReturnSubTypesApiCall.subscribe((activeSubtypes) => {
      this.showTypeSubType = activeSubtypes.length > 1;

      // Retrieve options for type and tag
      this.subscriptions.push(this.typeSubtypeService.getTaxReturnTypes()
        .subscribe(options => {
          this.taxReturnTypeOptions = options;
          if (!this.showTypeSubType && options.length) {
            this.taxReturnType.setValue(options[0].value);
          }
        }));
      this.subscriptions.push(this.taxReturnType.valueChanges
        .pipe(
          switchMap((val) => {
            if (val) {
              return this.typeSubtypeService.getTaxReturnSubTypesByType(+val);
            }
            // if type is not selected return empty list for subtype
            return observableOf([]);
          }))
        .subscribe(options => {
          this.taxReturnSubtypeOptions = options;
          if (!this.showTypeSubType && options.length) {
            this.taxReturnSubtype.setValue(options[0].value);
          }
        }));
    }));
  }
}
